import { v4 as uuid } from 'uuid'
import type { I18nTranslate } from '@lib/types/common'
import type { CollectionPlayerWithPages } from '@ppt-conversion-selector/types/model.type'

export const getDefaultNewGroupName = (t: I18nTranslate) => t('canvasUI.pptConversionSelector.defaultNewGroupName')
export const getDefaultGroupName = (t: I18nTranslate) => t('canvasUI.pptConversionSelector.defaultGroupName')

export const generateNewEmptyGroup = (t: I18nTranslate) => ({
  id: uuid(),
  name: getDefaultNewGroupName(t),
  slides: [],
})

export const generateNewCollection = (t: I18nTranslate) => ({
  name: t('canvasUI.pptConversionSelector.defaultNewCollectionName'),
  groups: [generateNewEmptyGroup(t)],
})

export const getAllSlidesCount = (data: CollectionPlayerWithPages) =>
  data.groups.reduce((acc, group) => acc + group.slides.length, 0)
export const findFirstSlide = (data: CollectionPlayerWithPages) =>
  data.groups.find((group) => group.slides.length)?.slides[0]
